Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAddressParser
  parse: (addressJson) ->
    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessAddressBuilder()
    builder.setRegionCode(addressJson.regionCode)
    builder.setAdministrativeArea(addressJson.administrativeArea)
    builder.setLocality(addressJson.locality)
    builder.setSubLocality(addressJson.subLocality)
    builder.setAddressLines(addressJson.addressLines)
    builder.build()
